var _path, _ellipse, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuFairIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 93,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11c0-3 2-5 5-5h90c3 0 5 2 5 5s-2 5-5 5H5c-3 0-5-2-5-5Z",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.5,
    cy: 10.6,
    rx: 10.5,
    ry: 10.6,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45 18h11v60H45z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 93H20c2-9 15-16 30-16s28 7 30 16ZM16 64c9 0 16-6 16-15 0-8-14-29-16-29-3 0-16 21-16 29 0 9 7 15 16 15Zm1-34h-2L7 44v2h17l1-2-8-14ZM84 64c9 0 16-6 16-15 0-8-13-29-16-29-2 0-16 21-16 29 0 9 7 15 16 15Zm1-34h-2l-8 14 1 2h17v-2l-8-14Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuFairIcon);
export default __webpack_public_path__ + "static/media/menu-fair-icon.0d2bcd57b719f58bcd48947db63f2470.svg";
export { ForwardRef as ReactComponent };